module.exports = __webpack_public_path__ + "static/media/banner-new-bg2.c7903a95.jpg";